module.exports = __webpack_public_path__ + "assets/img/f34fe1c0bb12b73dae5f44b8867f4ba7.png";